import { v4 as uuidv4 } from 'uuid';

export default {
  namespaced:true,
  state : {
    isUserActive: true,
    isLastActiveTab: true,
    idTab: null,
  },
  
  getters : {
    GETTERS_USER_ACTIVE: (state) => state.isUserActive,
    GETTERS_ID_TAB: (state) => state.idTab,
    GETTERS_TAB_ACTIVE: (state) => state.isLastActiveTab
  },
  
  mutations : {
    MUTATION_USER_ACTIVE (state, data) {
      state.isUserActive = data
    },
    MUTATION_ID_TAB (state, data) {
      state.idTab = data
    },
    MUTATION_TAB_ACTIVE (state, data) {
      state.isLastActiveTab = data
    },
  },
  
  actions : {
    async ACTION_USER_ACTIVE ({ commit, state }) {
      if(!state.idTab) {
        const newUuid = uuidv4()
        // console.log(newUuid)
        commit('MUTATION_ID_TAB', newUuid)
        localStorage.setItem('idLastActiveTab', newUuid)
      }
      //check user active from event focus
      if(state.isUserActive) {
        // console.log('set id last active tab')
        // console.log(state.idTab)
        localStorage.setItem('idLastActiveTab', state.idTab)
      }
    },
  }
} 